
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"16","height":"14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 0L0 7.2h2.182v6.546h3.636V8.655h4.364v5.09h3.636V7.2H16l-2.91-2.618v-3.2h-1.454v1.89z","fill":"#98A1AB","fill-rule":"evenodd"}})])
      }
    
      }
    